import axios from "axios";
import { useMutation } from "react-query";
import { END_POINT } from "config/environment";
import { ISubscriptionRuleUpdatePayload, TSubscriptionRule } from "../types";

export const updateSubscriptionRule = async (
  props: ISubscriptionRuleUpdatePayload
): Promise<TSubscriptionRule> => {
  const url = `${END_POINT.BASE_URL}/v1/administrator/subscription-rules/${props.id}`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${props.token}`,
    },
  };
  const { token, id, ...body } = props;
  const res = await axios.put<TSubscriptionRule>(url, body, config);
  return res.data;
};

export const useUpdateSubscriptionRule = () => {
  return useMutation(updateSubscriptionRule);
};
